import { jwtDecode } from "jwt-decode";
import Cookies from "js-cookie";
import appInfoDefaults from "../resources/app_info.json";
type TokenValues = {
    exp: number;
    isInchargeOfAiWorks: string;
    userId: string;
    backendUri: string;
    products: [];
    supportEnvHost: string;
    role: string;
    userSupportId: string;
};
interface UpdateDetails {
    updatesEN: {
        [key: string]: string[];
    };
    updatesJA: {
        [key: string]: string[];
    };
}

interface AppDetails {
    id: string;
    information: string;
    enable_OCR?: boolean;
    file_attachment?: {
        attachment_max_limit?: number | string;
        attachment_max_size?: number | string;
        accepted_upload_file_types?: string[];
    };
    aimodel_admin: { [key: string]: string };
    locales: { [key: string]: string };
    aimodel_user: { [key: string]: string };
    use_all_tab: boolean;
    enable_all_product_for_all_users?: boolean;
    disable_frontend_autoselect_fallback?: boolean;
    all_product_auto_select?: {
        enabled?: boolean;
        min_confidence?: number | string;
        min_margin?: number | string;
        min_hits?: number | string;
        min_avg_reranker_score?: number | string;
        min_avg_reranker_gap?: number | string;
        weight_average?: number | string;
        weight_peak?: number | string;
        weight_volume?: number | string;
    };
    product_manual_categories: { [key: string]: string };
    faq_categories: { [key: string]: string };
    document_categories: { [key: string]: string };
    wap_doc_categories: { [key: string]: string };
    client_doc_categories: { [key: string]: string };
    retrieval_mode: { [key: string]: string };
    feedbacktype: { [key: string]: string };
    semantic: { [key: string]: string };
    updates: {
        [key: string]: string[];
    };
    commonEn: {
        layout: {
            wap: string;
            headerTitle: string;
            manual: string;
            feedbackForm: string;
            faqAppName: string;
            faqAppLink: string;
            manualAppName: string;
            manualAppLink: string;
            bannerText: string;
            chat: string;
            feedbacks: string;
            reports: string;
        };
        chat: {
            title: string;
            input: string;
            inputPlaceholder: string;
            subtitle: string;
            productFilterTitle: string;
            productFilterText: string;
            documenttype: string;
            ALL: string;
            Private: string;
            Public: string;
            chatModel: string;
            conversationDate: string;
            today: string;
            last7days: string;
            last30days: string;
            feedbackuser: string;
            warning: string;
            ok: string;
        };
        example: {
            example1: string;
            example1Category: string;
            example1DocType: string;
            example2: string;
            example2Category: string;
            example2DocType: string;
            example3: string;
            example3Category: string;
            example3DocType: string;
        };
        settings: {
            title: string;
        };
        answer: {
            good: string;
            bad: string;
            thoughtProcess: string;
            supportingContent: string;
            additionalFeedback: string;
            goodFeedbackText: string;
            badFeedbackText: string;
            notTrue: string;
            notHelpful: string;
            harmful: string;
            submitButton: string;
            chatFeedback: string;
            citations: string;
            followupQuestions: string;
            generatedForProductLabel?: string;
            changeProductScenarioAndRegenerate?: string;
            page: string;
        };
        analysis: {
            thoughtProcess: string;
            supportingContent: string;
            citation: string;
        };
        supportingContent: {
            content: string;
            citationSource: string;
            originalSource: string;
            score: string;
            rerankerScore: string;
            documenttype: string;
            openinNewTab: string;
            openinNewWindow: string;
            noSupportingContent: string;
            viewFullContent: string;
        };
        appsettings: {
            save: string;
            appInfo: string;
            updateInfo: string;
        };
        clearChat: {
            clearChat: string;
            newChat: string;
        };
        questionInput: {
            AIResponseGenerationStopButton?: string;
            tooltip: string;
            allProductValidation?: {
                loadingMessage: string;
                confirmMessage: string;
                fallbackConfirmMessage?: string;
                matchedMessage?: string;
                continueWithAll: string;
                cancel: string;
                expandSuggestionsTooltip?: string;
                collapseSuggestionsTooltip?: string;
                panelTitle?: string;
                suggestionsTabLabel?: string;
                browseTabLabel?: string;
                browseHint?: string;
                browseSearchPlaceholder?: string;
                browseNoResults?: string;
                browseCatalogEmpty?: string;
                browseCatalogHelp?: string;
                browseVersionsSectionLabel?: string;
                browseSubProductsSectionLabel?: string;
                closePanelLabel?: string;
                zeroSuggestionsTitle?: string;
                zeroSuggestionsBody?: string;
                zeroSuggestionsBrowseCta?: string;
                zeroSuggestionsBrowseLead?: string;
                matchCountLabel?: string;
                matchCountTooltip?: string;
                confidenceLabel?: string;
                confidenceTooltip?: string;
                scoreLegendText?: string;
                autoSelectingMessage?: string;
                autoSelectingProgressLabel?: string;
                autoSelectionSkippedNoConfidence?: string;
                autoSelectionSkippedLowHits?: string;
                autoSelectionSkippedLowConfidence?: string;
                autoSelectionSkippedLowMargin?: string;
                loadingPhaseSearchCitations?: string;
                loadingPhaseScoreCandidates?: string;
                loadingPhaseApplyBestMatch?: string;
                loadingPhaseSkipAutoSelection?: string;
                autoSelectionDecisionTopLabel?: string;
                autoSelectionDecisionNextLabel?: string;
                autoSelectionDecisionGapLabel?: string;
                autoSelectionDecisionRequiredMarginLabel?: string;
                phaseMetaCandidateLabel?: string;
                phaseMetaRunnerUpLabel?: string;
                phaseMetaCandidatesLabel?: string;
                phaseMetaCitationsLabel?: string;
                searchDetailsTitle?: string;
                searchDetailsEmpty?: string;
                scoreDetailsTitle?: string;
                scoreDetailsEmpty?: string;
                detailsSourceLabel?: string;
                detailsProductLabel?: string;
                detailsVersionLabel?: string;
                detailsSubProductLabel?: string;
                detailsSearchScoreLabel?: string;
                detailsRerankerScoreLabel?: string;
                scoreDetailsHitsLabel?: string;
                scoreDetailsAverageLabel?: string;
                scoreDetailsPeakLabel?: string;
                scoreDetailsSamplesLabel?: string;
            };
        };
        regenerate: {
            regenerate: string;
        };
    };
    commonJa: {
        layout: {
            wap: string;
            headerTitle: string;
            manual: string;
            feedbackForm: string;
            faqAppName: string;
            faqAppLink: string;
            manualAppName: string;
            manualAppLink: string;
            bannerText: string;
            chat: string;
            feedbacks: string;
            reports: string;
        };
        chat: {
            title: string;
            input: string;
            inputPlaceholder: string;
            subtitle: string;
            productFilterTitle: string;
            productFilterText: string;
            documenttype: string;
            ALL: string;
            Private: string;
            Public: string;
            chatModel: string;
            conversationDate: string;
            today: string;
            last7days: string;
            last30days: string;
            feedbackuser: string;
            warning: string;
            ok: string;
        };
        example: {
            example1: string;
            example1Category: string;
            example1DocType: string;
            example2: string;
            example2Category: string;
            example2DocType: string;
            example3: string;
            example3Category: string;
            example3DocType: string;
        };
        settings: {
            title: string;
        };
        answer: {
            good: string;
            bad: string;
            thoughtProcess: string;
            supportingContent: string;
            additionalFeedback: string;
            goodFeedbackText: string;
            badFeedbackText: string;
            notTrue: string;
            notHelpful: string;
            harmful: string;
            submitButton: string;
            chatFeedback: string;
            citations: string;
            followupQuestions: string;
            generatedForProductLabel?: string;
            changeProductScenarioAndRegenerate?: string;
            page: string;
        };
        analysis: {
            thoughtProcess: string;
            supportingContent: string;
            citation: string;
        };
        supportingContent: {
            content: string;
            citationSource: string;
            originalSource: string;
            score: string;
            rerankerScore: string;
            documenttype: string;
            openinNewTab: string;
            openinNewWindow: string;
            noSupportingContent: string;
            viewFullContent: string;
        };
        clearChat: {
            clearChat: string;
            newChat: string;
        };
        questionInput: {
            AIResponseGenerationStopButton?: string;
            tooltip: string;
            allProductValidation?: {
                loadingMessage: string;
                confirmMessage: string;
                fallbackConfirmMessage?: string;
                matchedMessage?: string;
                continueWithAll: string;
                cancel: string;
                expandSuggestionsTooltip?: string;
                collapseSuggestionsTooltip?: string;
                panelTitle?: string;
                suggestionsTabLabel?: string;
                browseTabLabel?: string;
                browseHint?: string;
                browseSearchPlaceholder?: string;
                browseNoResults?: string;
                browseCatalogEmpty?: string;
                browseCatalogHelp?: string;
                browseVersionsSectionLabel?: string;
                browseSubProductsSectionLabel?: string;
                closePanelLabel?: string;
                zeroSuggestionsTitle?: string;
                zeroSuggestionsBody?: string;
                zeroSuggestionsBrowseCta?: string;
                zeroSuggestionsBrowseLead?: string;
                matchCountLabel?: string;
                matchCountTooltip?: string;
                confidenceLabel?: string;
                confidenceTooltip?: string;
                scoreLegendText?: string;
                autoSelectingMessage?: string;
                autoSelectingProgressLabel?: string;
                autoSelectionSkippedNoConfidence?: string;
                autoSelectionSkippedLowHits?: string;
                autoSelectionSkippedLowConfidence?: string;
                autoSelectionSkippedLowMargin?: string;
                loadingPhaseSearchCitations?: string;
                loadingPhaseScoreCandidates?: string;
                loadingPhaseApplyBestMatch?: string;
                loadingPhaseSkipAutoSelection?: string;
                autoSelectionDecisionTopLabel?: string;
                autoSelectionDecisionNextLabel?: string;
                autoSelectionDecisionGapLabel?: string;
                autoSelectionDecisionRequiredMarginLabel?: string;
                phaseMetaCandidateLabel?: string;
                phaseMetaRunnerUpLabel?: string;
                phaseMetaCandidatesLabel?: string;
                phaseMetaCitationsLabel?: string;
                searchDetailsTitle?: string;
                searchDetailsEmpty?: string;
                scoreDetailsTitle?: string;
                scoreDetailsEmpty?: string;
                detailsSourceLabel?: string;
                detailsProductLabel?: string;
                detailsVersionLabel?: string;
                detailsSubProductLabel?: string;
                detailsSearchScoreLabel?: string;
                detailsRerankerScoreLabel?: string;
                scoreDetailsHitsLabel?: string;
                scoreDetailsAverageLabel?: string;
                scoreDetailsPeakLabel?: string;
                scoreDetailsSamplesLabel?: string;
            };
        };
        regenerate: {
            regenerate: string;
        };
        appsettings: {
            save: string;
            appInfo: string;
            updateInfo: string;
        };
    };
    default_manual_products: string[];
    role_categories: { [key: string]: string };
}

type AllProductAutoSelectDefaults = NonNullable<AppDetails["all_product_auto_select"]>;
const appInfoAllProductAutoSelectDefaults = ((appInfoDefaults as any)?.all_product_auto_select ?? {}) as AllProductAutoSelectDefaults;
export const allProductAutoSelectStaticDefaults: AllProductAutoSelectDefaults = {
    enabled: appInfoAllProductAutoSelectDefaults?.enabled,
    min_confidence: appInfoAllProductAutoSelectDefaults?.min_confidence,
    min_margin: appInfoAllProductAutoSelectDefaults?.min_margin,
    min_hits: appInfoAllProductAutoSelectDefaults?.min_hits,
    min_avg_reranker_score: appInfoAllProductAutoSelectDefaults?.min_avg_reranker_score,
    min_avg_reranker_gap: appInfoAllProductAutoSelectDefaults?.min_avg_reranker_gap,
    weight_average: appInfoAllProductAutoSelectDefaults?.weight_average,
    weight_peak: appInfoAllProductAutoSelectDefaults?.weight_peak,
    weight_volume: appInfoAllProductAutoSelectDefaults?.weight_volume
};

interface UserDetails {
    userId: string;
    docValue: string;
    product: string;
    locale: string;
    aimodel: string;
    isSidebarOpen: string;
    apptype: string;
    isWap: string;
    corp_id: string;
    subProduct: string;
    isInchargeOfAiWorks: string;
    chatTourDone: string;
    answerTourDone: string;
    role: string;
    customer_corp_ids: string[];
    enable_all_product?: boolean;
}

export let backendUri = "";

export let productList = [];

export let isError = false;

export let supportEnvBoard = "";

export let isAdmin = false;

export let isNormalUser = false;

export let isViewer = false;

export let isEvaluator = false;

export let isConsultant = false;

export let userId = "";

export let userSupportId = "";

export let userRole = "";

type LocaleResourceKey = "commonEn" | "commonJa";
type AuthLabelKey = "invalidSession" | "pleaseLoginAgain" | "requestError" | "sessionExpired";

const getLocaleResourceKey = (): LocaleResourceKey => {
    const localeFromSession = sessionStorage.getItem("selectedLocale")?.toLowerCase() ?? "";
    if (localeFromSession.startsWith("en")) return "commonEn";
    if (localeFromSession.startsWith("ja")) return "commonJa";

    try {
        if (jwtToken && jwtToken.length > 0) {
            const decodedToken = jwtDecode<{ locale?: string }>(jwtToken);
            const localeFromToken = decodedToken?.locale?.toLowerCase() ?? "";
            if (localeFromToken.startsWith("en")) return "commonEn";
            if (localeFromToken.startsWith("ja")) return "commonJa";
        }
    } catch {
        // Fallback handled below.
    }

    const localeFromNavigator = (navigator.language ?? "").toLowerCase();
    return localeFromNavigator.startsWith("en") ? "commonEn" : "commonJa";
};

export const getAuthLabel = (key: AuthLabelKey): string => {
    const localeResourceKey = getLocaleResourceKey();
    const label = (appInfoDefaults as any)?.[localeResourceKey]?.auth?.[key];
    if (typeof label === "string" && label.trim().length > 0) return label;
    const jaFallback = (appInfoDefaults as any)?.commonJa?.auth?.[key];
    if (typeof jaFallback === "string" && jaFallback.trim().length > 0) return jaFallback;
    return `auth.${key}`;
};

function getHeaders(): HeadersInit {
    const headers: Record<string, string> = {
        "Content-Type": "application/json"
    };
    if (jwtToken && jwtToken != "" && jwtToken != undefined) {
        headers["Authorization"] = `Bearer ${jwtToken}`;
    }
    return headers;
}

async function fetchAppInfo(): Promise<AppDetails | any> {
    if (isError) {
        return;
    }
    const queryParams = new URLSearchParams();
    queryParams.append("load_products", JSON.stringify(true));
    if (productList?.length === 1 && productList[0] === "ALL") {
        queryParams.append("product_list", JSON.stringify([]));
    } else {
        queryParams.append("product_list", JSON.stringify(productList));
    }
    const response = await fetch("/load-app-info?" + queryParams, {
        method: "GET",
        headers: getHeaders()
    });
    if (!response.ok) {
        const result = await response.json();
        alert(`${result?.error}. ${getAuthLabel("pleaseLoginAgain")}`);
        if (result.redirect) {
            storeLatestURI();
            window.location.href = result.redirect;
        }
    }
    return await response.json();
}

async function fetchUserInfo(): Promise<UserDetails | any> {
    if (isError) {
        return;
    }
    const response = await fetch("/load-user-info", {
        method: "POST",
        headers: getHeaders(),
        body: JSON.stringify({})
    });
    if (!response.ok) {
        const result = await response.json();
        alert(`${result?.error}. ${getAuthLabel("pleaseLoginAgain")}`);
        if (result.redirect) {
            storeLatestURI();
            window.location.href = result.redirect;
        }
    }
    return await response.json();
}

async function fetchUpdateInfo(): Promise<UpdateDetails | any> {
    if (isError) {
        return;
    }
    const response = await fetch("/load-update-info", {
        method: "GET",
        headers: getHeaders()
    });
    if (!response.ok) {
        const result = await response.json();
        alert(`${result?.error}. ${getAuthLabel("pleaseLoginAgain")}`);
        if (result.redirect) {
            storeLatestURI();
            window.location.href = result.redirect;
        }
    }
    return await response.json();
}

async function getJwttoken(): Promise<string> {
    const jwtCookie = extractValidJwtToken(document.cookie);
    if (jwtCookie != "" && jwtCookie != undefined && jwtCookie.length > 5) {
        const tokenValues = jwtDecode(jwtCookie || "") as TokenValues;
        if (tokenValues?.exp > Date.now() / 1000 && tokenValues?.userId?.length > 0) {
            backendUri = tokenValues.backendUri ?? null;
            productList = tokenValues.products ?? [];
            const isIncharge = (tokenValues["isInchargeOfAiWorks"] || "").toLowerCase() === "true";
            const role = tokenValues["role"] || "";
            isAdmin = isIncharge || role === "Admin";
            isNormalUser = !isAdmin && (role === "User" || role === "");
            isViewer = tokenValues["role"] === "Viewer";
            isEvaluator = tokenValues["role"] === "Evaluator";
            isConsultant = tokenValues["role"] === "Consultant";
            userId = tokenValues.userId;
            userSupportId = tokenValues.userSupportId;
            userRole = tokenValues["role"];
            return jwtCookie;
        } else {
            Cookies.remove("token", { path: "/" });
            Cookies.remove("token", { path: "/assistant" });
            return "";
        }
    }
    if (jwtCookie) {
        return jwtCookie;
    } else {
        return "";
    }
}

function extractValidJwtToken(cookieString: string | undefined) {
    const cookies = cookieString?.split(";") ?? [];
    let validToken = null;

    for (const cookie of cookies) {
        const trimmedCookie = cookie.trim();
        if (trimmedCookie.startsWith("token=")) {
            const tokenParts = trimmedCookie.split("=");
            const token = tokenParts[1];
            if (token !== "") {
                validToken = token;
                break;
            }
        }
    }
    return validToken;
}

async function fetchBackendValue() {
    try {
        const response = await fetch("/assistant/home_env", {
            method: "GET"
        });
        const data = await response?.json();
        supportEnvBoard = data.support_env_board;
        return data.home_env_url;
    } catch (error) {
        console.log("Error fetching Home URL value:", error);
    }
}

async function validateTokenAndInitialize() {
    if (jwtToken && jwtToken != "" && jwtToken != undefined) {
        const tokenValues = jwtDecode(jwtToken ?? "") as TokenValues;
        if (tokenValues?.exp < Date.now() / 1000) {
            isError = true;
            alert(getAuthLabel("sessionExpired"));
            localStorage.removeItem("disclaimerHide");
            storeLatestURI();
            window.location.href = supportEnvHost;
        }
    } else {
        isError = true;
        alert(getAuthLabel("invalidSession"));
        storeLatestURI();
        window.location.href = supportEnvHost;
    }
}

export const supportEnvHost = await fetchBackendValue();

export const jwtToken = await getJwttoken();

await validateTokenAndInitialize();

export const appInfo = await fetchAppInfo();

export const userInfo = await fetchUserInfo();

export const isWapUser = userInfo?.isWap === "True" || userInfo?.isWap === "true" || userInfo?.isWap === true;

export const updateInfo = await fetchUpdateInfo();

function storeLatestURI() {
    const url = new URL(window.location.href);
    localStorage.setItem(
        "redirectAfterLogin",
        JSON.stringify({
            pathname: url.pathname,
            searchParams: Object.fromEntries(url.searchParams.entries())
        })
    );
}
